<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    :isConfirm="isConfirm"
    :width="width"
    append-to-body
  >
    <div slot="content">
      <el-card shadow="never">
        <div style="margin-bottom: 10px">
          <el-button
            size="small"
            type="danger"
            @click="btnUpdateIsAttended"
            :disabled="isEdit"
            >确认
          </el-button>
        </div>
        <el-table
          border
          hightlight-current-row
          :header-cell-class-name="headerRow"
          :data="personalTrainModel"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
          @selection-change="onSelectionChange"
        >
          <el-table-column
            type="selection"
            width="50"
            align="center"
            v-bind:selectable="chkstu"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column prop="Name" label="姓名" sortable></el-table-column>
          <el-table-column
            prop="Sex"
            label="性别"
            sortable
            :formatter="Sex"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="Phone"
            label="手机号"
            sortable
            align="right"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="IsAttended"
            label="是否到场"
            sortable
            :formatter="IsAttended"
            width="105"
          ></el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                v-if="!scope.row.IsAttended == 1"
                type="text"
                size="mini"
                @click="innerUpdateIsAttended(scope.row)"
                >确认
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </el-card>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      headerRow: "header-row",
      isConfirm: false,
      isloading: false,
      width: "70%",
      personalTrainModel: [],

      total: 0,
      currentPage: 1,
      pageSize: 15,

      batchId: "",
      isEdit: true,
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    OfDialog,
    OfPagination,
  },
  computed: {},
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //初始化数据
    loadData() {
      this.isloading=true
        let params={
        PageIndex:this.currentPage,
        PageSize:this.pageSize,
        ApplyId:this.dataForm.Id
        }
      api.QueryLifePersonByApplyId(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.personalTrainModel = rep.data.Data.rows;
        }
        this.isloading=false;
      });
    },
    IsAttended(rowData) {
      return rowData.IsAttended == 1 ? "是" : "否";
    },
    Sex(rowData) {
      return rowData.Sex == 0 ? "女" : "男";
    },
    chkstu(rowData) {
      return rowData.IsAttended == 1 ? false : true;
    },
    updateIsAttended(ids) {
        let params={Id:ids}
      api.UpdateLifePersonIsAttended(params)
        .then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.loadData();
            this.batchId = "";
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
      this.isloading = false;
    },
    innerUpdateIsAttended(rowData) {
      this.isloading = true;
      this.$confirm("请确认是否到场？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.updateIsAttended(rowData.Id);
      });
    },
    btnUpdateIsAttended() {
      this.isloading = true;
      if (this.batchId == "") return;
      this.$confirm("请确认是否到场？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.updateIsAttended(this.batchId);
      });
    },
    onSelectionChange(rowItems) {
      this.isEdit = !rowItems.length > 0;
      if (rowItems.length) {
        const ids = [];
        for (var i = 0; i < rowItems.length; i++) {
          ids.push(rowItems[i].Id);
        }
        this.batchId = ids.join(",");
      }
    },
  },
};
</script>

<style scoped>
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}
.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--default {
  display: none;
}
</style>

<style>
</style>
